module.exports = __webpack_public_path__ + "static/media/delete-white.18860acd.svg";